export type MarkdownAlign = 'left' | 'center' | 'right' | null;

export interface MarkdownTable {
  headers: string[];
  align: MarkdownAlign[];
  rows: string[][];
  next: number;
}

const MAX_COLUMNS = 12;
const MAX_ROWS = 200;

function cells(line: string): string[] {
  const trimmed = line.trim().replace(/^\|/, '').replace(/(?<!\\)\|$/, '');
  return trimmed.split(/(?<!\\)\|/).map((cell) => cell.trim().replace(/\\\|/g, '|'));
}

/**
 * Lit un tableau Markdown à en-tête et séparateur explicites. Une ligne au
 * nombre de cellules différent est complétée ou tronquée : un modèle en oublie
 * souvent une, et le tableau ne doit pas retomber en texte brut pour autant.
 */
export function markdownTable(lines: readonly string[], at: number): MarkdownTable | null {
  const headerLine = lines[at];
  const separatorLine = lines[at + 1];
  if (!headerLine?.includes('|') || !separatorLine?.includes('|')) return null;
  const headers = cells(headerLine);
  const separators = cells(separatorLine);
  if (headers.length < 2 || headers.length > MAX_COLUMNS || separators.length !== headers.length ||
      !separators.every((cell) => /^:?-+:?$/.test(cell))) return null;
  const align = separators.map((cell): MarkdownAlign => cell.startsWith(':') && cell.endsWith(':') ? 'center'
    : cell.endsWith(':') ? 'right' : cell.startsWith(':') ? 'left' : null);
  const rows: string[][] = [];
  let next = at + 2;
  while (next < lines.length && rows.length < MAX_ROWS) {
    const line = lines[next] ?? '';
    if (!line.trim() || !line.includes('|')) break;
    const row = cells(line).slice(0, headers.length);
    while (row.length < headers.length) row.push('');
    rows.push(row);
    next++;
  }
  return { headers, align, rows, next };
}
